import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalRepliesSentConfig = {
    name: 'kpi.twitter.total_replies_sent',
    id: 'reply_tweets',
    tooltip: 'kpi.twitter.tooltip_total_replies_sent',
    icon: {
        name: 'reply',
        style: colors.yellow
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    orientation: ORIENTATION_VERTICAL,
    size: SIZE_25,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
